import { FancyCheckbox } from "@common/controls/Inputs/Checkbox/component";

import "./style.less";

export default FancyCheckbox;

export { type CheckboxProps } from "@common/controls/Inputs/Checkbox/component";
